import { useSelector } from "react-redux";
import { State } from "../../../state/store";

export const useInformationApiResult = () => {

    const processing = useSelector((state: State) => state.information.processing);
    const registerHasCorrect = useSelector((state: State) => state.information.registerSucceeded);
    const registerHasError = useSelector((state: State) => state.information.registerFailed);
    const deleteHasCorrect = useSelector((state: State) => state.information.deleteSucceeded);
    const deleteHasError = useSelector((state: State) => state.information.deleteFailed);

    return [processing, registerHasCorrect, registerHasError, deleteHasCorrect, deleteHasError] as const;
};
